/**
 * Description  :
 * Version      : 1.0.0
 * Author       : Luoye
 * Date         : 2022-08-12 09:56:46
 * LastEditors  : Luoye
 * FilePath     : /partner_web/src/common/config/index.ts
 * Copyright (C) 2022 rose. All rights reserved.
 */

let PAGE_HOST = 'https://m.namibox.com';
let PARTNER_HOST = 'https://partner.namibox.com';
let MAIN_WEB_HOST = 'https://namibox.com';
let NMS_HOST = 'https://nmsx.namibox.com:8553';
let OA_HOST = 'https://nmsx.namibox.com:9663';
let EOMS_HOST = 'https://eoms.namibox.com';
let PLUTO_HOST = 'https://pluto-web.namibox.com';
let OSSURL = 'https://f.namibox.com';
let TINAHOST = 'https://namibox.com';
let BUCKET = 'namibox';
let RaceHost = 'https://race.namibox.com';
if (APP_ENV === 'test' || APP_ENV === 'development') {
  PAGE_HOST = 'https://m-test.namibox.com';
  PARTNER_HOST = 'https://sop-test.namibox.com';
  MAIN_WEB_HOST = 'https://wweb.namibox.com';
  NMS_HOST = 'https://wnms.namibox.com';
  OA_HOST = '';
  EOMS_HOST = 'https://oms-test.namibox.com';
  PLUTO_HOST = 'https://pluto-web-test.namibox.com';
  OSSURL = 'https://wf.namibox.com';
  TINAHOST = 'https://wweb.namibox.com';
  BUCKET = 'namibox-w';
  RaceHost = 'https://race-test.namibox.com';
} else if (APP_ENV === 'shadow') {
  PAGE_HOST = 'https://m-test.namibox.com/144';
  PARTNER_HOST = 'https://sop.namibox.com';
  MAIN_WEB_HOST = 'https://150.namibox.com';
  NMS_HOST = 'https://nmsx.namibox.com:8553';
  OA_HOST = 'https://nmsx.namibox.com:9663';
  EOMS_HOST = 'https://eoms-144.namibox.com';
  PLUTO_HOST = 'https://pluto-web.namibox.com';
  OSSURL = 'https://wf.namibox.com';
  TINAHOST = 'https://wweb.namibox.com';
  BUCKET = 'namibox-w';
  RaceHost = 'https://race-test.namibox.com';
} else if (APP_ENV === 'local') {
  PAGE_HOST = 'https://m-test.namibox.com';
  PARTNER_HOST = '';
  MAIN_WEB_HOST = 'https://wweb.namibox.com';
  NMS_HOST = 'https://wnms.namibox.com';
  OA_HOST = '';
  EOMS_HOST = 'https://oms-test.namibox.com';
  PLUTO_HOST = 'https://pluto-web-test.namibox.com';
  OSSURL = 'https://wf.namibox.com';
  TINAHOST = 'https://wweb.namibox.com';
  BUCKET = 'namibox-w';
  RaceHost = 'https://race-test.namibox.com';
}

export {
  PARTNER_HOST,
  MAIN_WEB_HOST,
  NMS_HOST,
  OA_HOST,
  PAGE_HOST,
  EOMS_HOST,
  PLUTO_HOST,
  OSSURL,
  TINAHOST,
  BUCKET,
  RaceHost,
};

export function getPageHost(name = '') {
  if (location.href.indexOf('x.namibox.com') > -1) {
    return `https://x.namibox.com/${name}.html`;
  }
  return `${PAGE_HOST}/${name}/`;
}

export function handleReqURl(url: string, data?: object) {
  const reg = /https?:\/\//;
  if (!url || reg.test(url)) {
    return url;
  }
  let str = '';
  if (data) {
    let index = 0;
    for (const [key, value] of Object.entries(data)) {
      str += index === 0 ? `${key}=${value}` : `&${key}=${value}`;
      index += 1;
    }
  }
  if (str) {
    return /* APP_ENV === 'development' ? `${url}?${str}` :  */ `${PARTNER_HOST}${url}?${str}`;
  }
  return /* APP_ENV === 'development' ? url : */ `${PARTNER_HOST}${url}`;
}
export function handleRaceReqURl(url: string, data?: object) {
  // const RaceHost = 'https://race-test.namibox.com';
  const reg = /https?:\/\//;
  if (!url || reg.test(url)) {
    return url;
  }
  let str = '';
  if (data) {
    let index = 0;
    for (const [key, value] of Object.entries(data)) {
      str += index === 0 ? `${key}=${value}` : `&${key}=${value}`;
      index += 1;
    }
  }
  if (str) {
    return /* APP_ENV === 'development' ? `${url}?${str}` :  */ `${RaceHost}${url}?${str}`;
  }
  return /* APP_ENV === 'development' ? url : */ `${RaceHost}${url}`;
}
export function handleRaceReqURlsse(url: string, data?: object) {
  // const RaceHost = 'https://race-test.namibox.com';
  const reg = /https?:\/\//;
  if (!url || reg.test(url)) {
    return url;
  }
  let str = '';
  if (data) {
    let index = 0;
    for (const [key, value] of Object.entries(data)) {
      if (Array.isArray(value)) {
        value.forEach((item) => {
          str += index === 0 ? `${key}=${item}` : `&${key}=${item}`;
          index += 1;
        });
      } else {
        str += index === 0 ? `${key}=${value}` : `&${key}=${value}`;
        index += 1;
      }
    }
  }
  if (str) {
    return /* APP_ENV === 'development' ? `${url}?${str}` :  */ `${RaceHost}${url}?${str}`;
  }
  return /* APP_ENV === 'development' ? url : */ `${RaceHost}${url}`;
}
